<template>
  <div v-loading="loading" element-loading-text="加载中..." class="app-container">
    <el-form ref="detailForm" :model="detail" :rules="rules" label-width="120px" :label-position="device === 'mobile' ? 'top' : 'right'">
      <el-collapse v-model="activeCollapses" class="el-card-collapse">
        <el-collapse-item title="基本信息" name="Basic">
          <el-row :gutter="20">
            <el-col :xs="24" :md="16">
              <el-form-item label="礼包名称" prop="goodsName">
                <el-input v-model.trim="detail.goodsName" placeholder="请输入礼包名称" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-form-item class="inline-form-item" label="商品单位">
                <el-select v-model="detail.goodsUnit" filterable allow-create placeholder="件 / 箱 / 个 / 盒" clearable>
                  <el-option v-for="(item, index) in units" :key="index" :label="item" :value="item" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :xs="24" :sm="8">
              <el-form-item class="inline-form-item" label="用户身份">
                <el-select v-model="detail.userGrade" placeholder="请选择身份分类" clearable>
                  <el-option v-for="(item, index) in grades" :key="index" :label="item.levelName" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-form-item class="inline-form-item" label="礼包分类">
                <el-select v-model="detail.giftType" placeholder="请选择礼包分类" clearable>
                  <el-option label="身份礼包" :value="0" />
                  <el-option label="收益礼包" :value="1" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item class="inline-form-item" label="显示排序">
                <el-input v-model="detail.sortBy" type="number" step="1" class="max-width" placeholder="商品在前端的排序" />
                <el-tooltip content="商品在小程序的显示顺序，数字真小越前">
                  <i class="el-icon-warning-outline ml-5" style="cursor: pointer;" />
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :xs="24" :sm="8">
              <el-form-item class="inline-form-item" label="所属专区">
                <el-select v-model="detail.categoryId" placeholder="请选择专区分类" clearable>
                  <el-option-group v-for="(group, gid) in categories" :key="gid" :label="group.name">
                    <el-option v-for="(item, index) in group.children" :key="index" :label="item.name" :value="item.id" />
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-form-item class="inline-form-item" label="供应商">
                <el-select v-model="detail.supplierId" filterable placeholder="请选择供应商" clearable>
                  <el-option v-for="(item, index) in suppliers" :key="index" :label="item.supplierName" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="礼包图片" prop="cover">
                <div class="image-uploader">
                  <el-upload
                    action="#"
                    accept="image/*"
                    class="avatar-uploader"
                    :show-file-list="false"
                    :on-change="imageChange.bind(null, { key: 'cover' })"
                    :http-request="imageUpload.bind(null, { key: 'cover' })"
                  >
                    <template v-if="coverImage.url">
                      <img :src="coverImage.url" class="avatar">
                      <div class="el-upload-img-actions">
                        <span class="el-upload-img-preview" @click.stop="imagePreview({ key: 'cover' })">
                          <i class="el-icon-zoom-in" />
                        </span>
                        <span class="el-upload-img-delete" @click.stop="imageBeforeRemove({ key: 'cover' })">
                          <i class="el-icon-delete" />
                        </span>
                      </div>
                    </template>
                    <i v-else class="el-icon-plus avatar-uploader-icon" />
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="16">
              <el-form-item label="礼包轮播图" prop="galleries">
                <el-upload
                  action="#"
                  :limit="9"
                  multiple
                  accept="image/*"
                  list-type="picture-card"
                  :file-list="galleries"
                  :on-change="imageChange.bind(null, { key: 'galleries' })"
                  :on-remove="imageRemove.bind(null, { key: 'galleries' })"
                  :on-preview="imagePreview.bind(null, { key: 'galleries' })"
                  :http-request="imageUpload.bind(null, { key: 'galleries' })"
                  :before-remove="imageBeforeRemove.bind(null, { key: 'galleries' })"
                >
                  <i class="el-icon-plus" />
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :xs="24" :sm="6">
              <el-form-item class="inline-form-item" label="上架">
                <el-switch v-model="detail.isOnsale" :width="60" class="rectangle" active-color="#13ce66" :active-value="1" :inactive-value="0" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item class="inline-form-item width-120" label="是否可以复购">
                <el-switch v-model="detail.canRebuy" :width="60" class="rectangle" active-color="#13ce66" :active-value="1" :inactive-value="0" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-form-item class="inline-form-item" label="需要分享">
                <el-switch v-model="detail.needShare" :width="60" class="rectangle" active-color="#13ce66" :active-value="1" :inactive-value="0" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>

        <el-collapse-item title="礼包价格" name="Prices">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="6">
              <el-form-item class="inline-form-item" label="供货价" prop="stockPrice">
                <el-input v-model="detail.stockPrice" type="number" step="0.01" class="max-width" placeholder="请输入供货价">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6">
              <el-form-item class="inline-form-item" label="成本价" prop="costPrice">
                <el-input v-model="detail.costPrice" type="number" step="0.01" class="max-width" placeholder="请输入成本价">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6">
              <el-form-item class="inline-form-item" label="零售价" prop="retailPrice">
                <el-input v-model="detail.retailPrice" type="number" step="0.01" class="max-width" placeholder="请输入零售价" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="6">
              <el-form-item class="inline-form-item" label="积分售价" prop="pointPrice">
                <el-input v-model="detail.pointPrice" type="number" step="0.01" class="max-width" placeholder="请输入使用积分的零售价">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6">
              <el-form-item class="inline-form-item" label="优惠积分" prop="point">
                <el-input v-model="detail.point" type="number" step="0.01" class="max-width" placeholder="请输入所需积分" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="6">
              <el-form-item class="inline-form-item" label="扣除分享人积分" prop="deductSharePoint">
                <el-input v-model="detail.deductSharePoint" type="number" step="0.01" class="max-width" placeholder="请输入扣除分享人积分数" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6">
              <el-form-item class="inline-form-item" label="回收推荐人积分" prop="refundPoint">
                <el-input v-model="detail.refundPoint" type="number" step="0.01" class="max-width" placeholder="请输入回收推荐人积分数" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <el-row :gutter="20" style="display: none;">
            <el-col :xs="24" :sm="12" :md="6">
              <el-form-item class="inline-form-item" label="券售价" prop="couponPrice">
                <el-input v-model="detail.couponPrice" type="number" class="max-width" placeholder="请输入使用券的零售价">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6">
              <el-form-item class="inline-form-item" label="消费券" prop="coupon">
                <el-input v-model="detail.coupon" type="number" step="0.01" class="max-width" placeholder="请输入所需消费券" />
              </el-form-item>
            </el-col>
          </el-row> -->

          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="6">
              <el-form-item class="inline-form-item width-120" label="赠送积分" prop="firstPoint">
                <el-input v-model="detail.firstPoint" type="number" class="max-width" placeholder="请输入赠送积分" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" style="display: none;">
              <el-form-item class="inline-form-item width-120" label="复购返回积分" prop="againPoint">
                <el-input v-model="detail.againPoint" type="number" class="max-width" placeholder="请输入复购返回积分" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" style="display: none;">
              <el-form-item class="inline-form-item width-120" label="返还消费券" prop="refundCoupon">
                <el-input v-model="detail.refundCoupon" class="max-width" placeholder="请输入返还消费券" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6">
              <el-form-item class="inline-form-item" label="分享名额" prop="quota">
                <el-input v-model="detail.quota" class="max-width" placeholder="请输入分享名额" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="6">
              <el-form-item class="inline-form-item" label="配送费用" prop="freightPrice">
                <el-input v-model="detail.freightPrice" type="number" class="max-width" placeholder="请输入配送费用">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6">
              <el-form-item class="inline-form-item" label="礼包库存" prop="quantity">
                <el-input v-model="detail.quantity" class="max-width" placeholder="请输入礼包库存量" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>

        <!-- <el-collapse-item v-if="detail.userGrade === 3" name="Promotion"> -->
        <el-collapse-item name="Promotion">
          <template slot="title">
            <span>营销管理</span>
            <el-button type="primary" icon="el-icon-plus" size="mini" style="margin-left: 20px;" @click.stop="addPromotion">增加营销设置</el-button>
          </template>
          <promo-table :list.sync="detail.promotions" @edit="handleModify" />
        </el-collapse-item>

        <el-collapse-item title="礼包介绍" name="Introduction">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item prop="planText">
                <my-editor v-model="detail.intro" :text.sync="detail.planText" :images.sync="editorImages" :not-exists.sync="deletedImages" :auto-focus="false" @change="editorChange" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
      <el-image ref="elImage" style="width: 0; height: 0;" :src="previewImg" :preview-src-list="previewList" />
    </el-form>

    <div class="app-form-button-group">
      <el-button icon="el-icon-back" @click="onBack">返回列表</el-button>
      <el-button type="info" @click="onCreateGoods">新增礼包</el-button>
      <el-button type="primary" @click="onSubmit">提交保存</el-button>
    </div>

    <el-dialog :title="promoDialogTitle" :visible.sync="promoDialogVisible" width="700px" :fullscreen="device==='mobile'">
      <el-form ref="promoForm" :model="promotion" :rules="promoRules" label-width="100px" :label-position="device === 'mobile' ? 'top' : 'right'">
        <el-row :gutter="20">
          <el-col :xs="24" :md="10">
            <el-form-item class="inline-form-item width-100" label="促销赠送积分" prop="givePoint">
              <el-input v-model="promotion.givePoint" type="number" class="max-width" placeholder="请输入促销赠送积分" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="14">
            <el-form-item class="inline-form-item width-100" label="赠送方式">
              <el-radio-group v-model="promotion.giftPointType" class="flex-row">
                <el-radio :label="1">直接赠送</el-radio>
                <el-radio :label="2">在原数量上累加</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="display: none;">
          <el-col :xs="24" :md="10">
            <el-form-item class="inline-form-item width-100" label="返回券数量" prop="giveCoupon">
              <el-input v-model="promotion.giveCoupon" type="number" class="max-width" placeholder="请输入返回券数量" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="14">
            <el-form-item class="inline-form-item width-100" label="返回方式">
              <el-radio-group v-model="promotion.giftCouponType" class="flex-row">
                <el-radio :label="1">直接返回</el-radio>
                <el-radio :label="2">在原数量上累加</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :md="10">
            <el-form-item class="inline-form-item width-100" label="促销赠送名额" prop="quota">
              <el-input v-model="promotion.quota" type="number" class="max-width" placeholder="请输入促销赠送名额" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="14">
            <el-form-item class="inline-form-item width-100" label="返回方式">
              <el-radio-group v-model="promotion.returnQuotaType" class="flex-row">
                <el-radio :label="1">占用部分</el-radio>
                <el-radio :label="2">在原数量上累加</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item class="inline-form-item width-100" label="促销日期">
              <el-date-picker v-model="promotion.startDate" class="max-width" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="开始日期" />
              <span class="ml-10 mr-10">至</span>
              <el-date-picker v-model="promotion.endDate" class="max-width" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="结束日期" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <template slot="footer">
        <el-button @click.native="promoDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click.native="handleSubmit">确定提交</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { uploadFile } from '@/api/oss'
import MyEditor from '@/components/MyEditor'
import PromoTable from './components/PromoTable'
import { saveGoods, getDetail } from '@/api/goods'

export default {
  name: 'GiftPackDetail',
  components: { MyEditor, PromoTable },
  props: {
    isCreate: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const checkCover = (rule, value, callback) => {
      if (!this.coverImage || !this.coverImage.url) {
        return callback('请上传礼包图片')
      } else {
        callback()
      }
    }
    const checkGalleries = (rule, value, callback) => {
      if (!this.galleries || this.galleries.length === 0) {
        return callback('请至少上传一张轮播图片')
      } else {
        callback()
      }
    }

    return {
      loading: false,
      detail: {},
      previewImg: undefined,
      previewList: [],
      galleries: [],
      editorImages: [],
      deletedImages: [],
      coverImage: { url: '', file: undefined },
      activeCollapses: ['Basic', 'Prices', 'Promotion', 'Introduction'],
      rules: {
        goodsName: [{ required: true, message: '请输入礼包名称', trigger: 'blur' }],
        retailPrice: [{ required: true, message: '请输入购买所需总价', trigger: 'blur' }],
        pointPrice: [{ required: true, message: '请输入使用积分的零售价', trigger: 'blur' }],
        // point: [{ required: true, message: '请输入购买所需积分数', trigger: 'blur' }],
        deductSharePoint: [{ required: true, message: '请输入扣除分享人积分数', trigger: 'blur' }],
        refundPoint: [{ required: true, message: '请输入回收推荐人积分数', trigger: 'blur' }],
        // couponPrice: [{ required: true, message: '请输入使用券的零售价', trigger: 'blur' }],
        // coupon: [{ required: true, message: '请输入购买所需券数', trigger: 'blur' }],
        quantity: [{ required: true, message: '请输入库存量', trigger: 'blur' }],
        freightPrice: [{ required: true, message: '请输入配送费用', trigger: 'blur' }],
        stockPrice: [{ required: true, message: '请输入供货价', trigger: 'blur' }],
        costPrice: [{ required: true, message: '请输入成本价', trigger: 'blur' }],
        firstPoint: [{ required: true, message: '请输入首次返回积分数', trigger: 'blur' }],
        againPoint: [{ required: true, message: '请输入复购返回积分数', trigger: 'blur' }],
        refundCoupon: [{ required: true, message: '请输入返还消费券', trigger: 'blur' }],
        quota: [{ required: true, message: '请输入名额', trigger: 'blur' }],
        cover: [{ required: true, validator: checkCover, trigger: 'change' }],
        galleries: [{ required: true, validator: checkGalleries, trigger: 'change' }],
        planText: [{ required: true, message: '请输入礼包详情介绍', trigger: 'change' }]
      },
      promoRules: {
        givePoint: [{ required: true, message: '请输入返回积分', trigger: 'blur' }],
        quota: [{ required: true, message: '请输入名额', trigger: 'blur' }]
      },
      promotion: {},
      promoDialogTitle: '',
      promoDialogVisible: false
    }
  },
  computed: {
    ...mapState({
      device: state => state.app.device,
      grades: state => state.base.memberLevels,
      categories: state => state.base.categoryList.filter(item => item.mallType === 4),
      suppliers: state => state.base.supplierList,
      units: state => state.base.units
    })
  },
  watch: {
    // 进货价（供货价）
    'detail.stockPrice': {
      handler(newPrice) {
        const stockPrice = parseFloat(newPrice)
        if (this.detail && !isNaN(stockPrice)) {
          const newCostPrice = stockPrice * 110 / 100
          const oldCostPrice = parseFloat(this.detail.costPrice)
          if (isNaN(oldCostPrice) || newCostPrice > oldCostPrice) {
            // 成本价 = 进货价 x 110%
            this.detail.costPrice = this.$util.formatNumber(newCostPrice, 2, '')
          }
        }
      }
    }
  },
  created() {
    if (!this.isCreate) {
      const goodsId = this.$route.query.id || undefined
      if (goodsId) this.fetchData(goodsId)
    } else {
      this.init()
    }
  },
  methods: {
    init() {
      this.loading = true
      this.detail = {
        goodsName: '',    // 商品名称
        cover: '',        // 封面图片
        intro: '',        // 商品详情（带有html标签）
        planText: '',     // 商品详情（不带html标签）
        stockPrice: 0,    // 供货价（厂家供货价）
        costPrice: 0,     // 成本价（供货价ｘ110%＋物流＋包装）
        freightPrice: 0,  // 配送费用
        retailPrice: 0,   // 零售价（成本价＋利润）
        pointPrice: 0,
        point: 0,         // 所需积分
        deductSharePoint: 0,
        refundPoint: 0,
        needShare: 0,
        couponPrice: 0,
        coupon: 0,        // 所需消费券
        quantity: 0,      // 库存
        isOnsale: 1,      // 状态（0 下架 1 上架）
        mallType: '4',    // 销售位置（1 积分商城 2 优品商城 3 福利商城 4 特权礼包）
        galleries: [],    // 商品图片画廊
        firstPoint: 0,    // 首次返回积分
        againPoint: 0,    // 复购返回积分
        refundCoupon: 0,  // 返还消费券
        quota: 0,         // 名额
        canRebuy: 0,      // 是否可以复购（0 否 1 是）
        userGrade: 2,     // 用户身份
        giftType: 0,      // 礼包类型（0 身份礼包 1 收益礼包）
        priceType: 0,     // 价格类型：0 纯现金，现金+积分，现金+券 1 纯积分 2 现金+积分 3 现金+券 4 积分+券 5 现金+积分，现金+券
        categoryId: '',   // 专区分类
        sortBy: 999,      // 前端显示排序
        supplierId: '',   // 供应商
        promotions: []    // 促销设置
      }
      this.galleries = []
      this.editorImages = []
      this.deletedImages = []
      this.coverImage = { url: '', file: undefined }
      this.$util.delay(500).then(() => { this.loading = false })
    },
    fetchData(goodsId) {
      this.loading = true
      getDetail(goodsId).then(goods => {
        const images = this.$util.getElementsByType(goods.intro, 'img')
        if (images && images.length) {
          this.editorImages = images.map(img => ({ url: img.src, old: img.src, file: undefined }))
        }
        if (goods.galleries && goods.galleries.length) {
          this.galleries = goods.galleries.map(item => ({ url: item, file: undefined }))
        }
        this.coverImage = Object.assign({}, { url: goods.cover, file: undefined })
        this.deletedImages = []
        this.detail = goods
      }).finally(() => {
        this.$util.delay(500).then(() => { this.loading = false })
      })
    },
    imageChange(obj, file, files) {
      if (!file) return false

      const isImage = `${file.raw.type}`.startsWith('image/')
      if (!isImage) return this.$message.warning('上传的文件必须是图片')

      if (obj.key === 'cover') {
        this.coverImage.url = URL.createObjectURL(file.raw)
        this.$refs.detailForm.validateField('cover')
      } else {
        const images = files.map(image => {
          const index = this.galleries.findIndex(item => item.uid === image.uid)
          return { uid: image.uid, url: image.url, file: index >= 0 ? this.galleries[index].file : undefined }
        })
        this.galleries = [...images]
        this.$refs.detailForm.validateField('galleries')
      }
    },
    imageUpload(obj, form) {
      const formData = new FormData()
      formData.append('file', form.file)
      formData.append('name', form.file.name)
      formData.append('fileSize', form.file.size)
      formData.append('fileType', form.file.type)

      if (obj.key === 'cover') {
        this.coverImage.file = formData
      } else {
        const image = this.galleries.find(item => item.uid === form.file.uid)
        if (image) image.file = formData
        this.$refs.detailForm.validateField('galleries')
      }
    },
    imagePreview(obj, file) {
      const imageUrl = obj.key === 'cover' ? this.coverImage.url : file.url
      this.previewImg = imageUrl
      this.previewList = [imageUrl]
      this.$nextTick(() => this.$refs.elImage.clickHandler())
    },
    imageBeforeRemove(obj, file) {
      if (obj.key === 'cover') {
        this.$confirm('确定删除该图片？', '温馨提示', { type: 'warning' }).then(() => {
          this.imageRemove(obj, file)
        }).catch(() => {})
      } else {
        return this.$confirm('确定删除该图片？', '温馨提示', { type: 'warning' })
      }
    },
    imageRemove(obj, file) {
      if (obj.key === 'cover') {
        this.coverImage = Object.assign({}, { url: '', file: undefined })
        this.$refs.detailForm.validateField('cover')
      } else {
        const index = this.galleries.findIndex(item => item.uid === file.uid)
        this.galleries.splice(index, 1)
        this.$refs.detailForm.validateField('galleries')
      }
    },
    addPromotion(e) {
      this.promotion = {
        id: undefined,
        goodsId: this.detail.id,
        givePoint: 0,
        giftPointType: 2,
        giveCoupon: 0,
        giftCouponType: 1,
        quota: 0,
        returnQuotaType: 1,
        startDate: undefined, // 开始时间
        endDate: undefined,   // 结束时间
        status: 0             // 状态：0 未开始 1 进行中 2 已结束
      }
      this.promoDialogTitle = '增加营销设置'
      this.promoDialogVisible = true
    },
    handleModify(e) {
      this.promotion = e.value
      this.promoDialogTitle = '编辑营销设置'
      this.promoDialogVisible = true
    },
    handleSubmit() {
      if (this.promotion.startDate) {
        if (this.promotion.endDate) {
          let days = this.$util.dateDiff(this.promotion.startDate, this.promotion.endDate)
          if (days <= 1) return this.$message.warning('促销开始日期必须小于结束日期')

          days = this.$util.dateDiff(this.$util.getToday(), this.promotion.endDate)
          if (days <= 1) return this.$message.warning('促销结束日期必须大于当前日期')
        }
      } else {
        return this.$message.warning('请设置促销开始日期')
      }
      this.promotionOnSubmit()
    },
    promotionOnSubmit() {
      this.$refs.promoForm.validate(valid => {
        if (!valid) return false
        if (this.detail.promotions && this.detail.promotions.length) {
          if (this.promotion.id) {
            this.detail.promotions = this.detail.promotions.map(item => item.id === this.promotion.id ? this.promotion : item)
          } else {
            this.detail.promotions.unshift(this.promotion)
          }
        } else {
          this.detail.promotions = [this.promotion]
        }

        this.promoDialogVisible = false
      })
    },
    editorChange() {
      this.$refs.detailForm.validateField('planText')
    },
    uploadImages() {
      return new Promise((resolve, reject) => {
        const uploadPromises = []
        const files = this.galleries.filter(item => !!item.file)
        if (files && files.length) files.forEach(item => uploadPromises.push(uploadFile(item.file)))

        this.deletedImages.forEach(item => {
          const index = this.editorImages.findIndex(img => img.url === item.url)
          this.editorImages.splice(index, 1)
        })
        const editorFiles = this.editorImages.filter(item => !!item.file)
        if (editorFiles && editorFiles.length) editorFiles.forEach(item => uploadPromises.push(uploadFile(item.file)))

        if (this.coverImage.file) uploadPromises.push(uploadFile(this.coverImage.file))
        if (uploadPromises && uploadPromises.length) {
          Promise.all(uploadPromises).then(response => {
            const filesLength = (files && files.length) ? files.length : 0
            if (filesLength > 0) {
              files.forEach((item, index) => {
                const oIndex = this.galleries.findIndex(img => img.url === item.url)
                if (oIndex >= 0) {
                  item = Object.assign({}, item, { url: response[index], file: undefined })
                  this.galleries.splice(oIndex, 1, item)
                }
              })
            }

            if (editorFiles && editorFiles.length) {
              editorFiles.forEach((item, index) => {
                const oIndex = this.editorImages.findIndex(img => img.url === item.url)
                if (oIndex >= 0) {
                  item = Object.assign({}, item, { url: response[filesLength + index], file: undefined })
                  this.editorImages.splice(oIndex, 1, item)
                }
              })
            }
            this.editorImages.forEach(item => {
              this.detail.intro = `${this.detail.intro}`.replace(item.old, item.url)
            })
            if (this.coverImage.file) this.coverImage = { url: response[response.length - 1], file: undefined }
            resolve()
          }).catch(() => reject('图片上传失败'))
        } else {
          resolve()
        }
      })
    },
    onSubmit() {
      this.$refs.detailForm.validate(async(valid) => {
        if (!valid) return false

        this.loading = true
        // 上传商品图片
        this.uploadImages().then(() => {
          this.detail.cover = this.coverImage.url
          this.detail.galleries = this.galleries.map(item => item.url)
          if (this.detail.promotions && this.detail.promotions.length) {
            this.detail.promotions.forEach(promotion => {
              promotion.retailPrice = this.detail.retailPrice
              promotion.pointPrice = this.detail.pointPrice
              promotion.point = this.detail.point
            })
          }

          delete this.detail.planText
          return saveGoods(this.detail)
        }).then(response => {
          this.$util.delay(500).then(() => {
            this.loading = false
            this.$confirm('礼包资料保存成功，是否继续添加？', '温馨提示', {
              confirmButtonText: '继续添加',
              cancelButtonText: '返回列表',
              type: 'success'
            }).then(() => this.onCreateGoods()).catch(() => this.onBack())
          })
        }).catch(() => {
          this.$message.error('礼包资料提交保存失败')
          this.loading = false
        })
      })
    },
    onCreateGoods() {
      this.galleries = []
      this.coverImage = {}
      this.editorImages = []
      this.deletedImages = []
      if (this.isCreate) {
        this.init()
      } else {
        this.$refs.detailForm.resetFields()
      }
    },
    onBack() {
      this.$store.dispatch('tagsView/delView', this.$route)
      const from = this.$route.query.from || ''
      if (from === 'list') {
        this.$router.go(-1)
      } else {
        this.$router.push({ path: `/goods/gift/list` })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  padding-bottom: 50px;
}
.mobile .inline-form-item ::v-deep {
  .el-form-item__label {
    width: 85px;
    min-width: 85px;
  }
  .max-width {
    max-width: 100%;
  }
  .el-date-editor--daterange.el-input__inner {
    width: 100%;
  }
}
.mobile .inline-form-item.width-100 ::v-deep {
  .el-form-item__label {
    width: 100px;
    min-width: 100px;
  }
}
.mobile .inline-form-item.width-120 ::v-deep {
  .el-form-item__label {
    width: 120px;
    min-width: 120px;
  }
}
</style>
